import NucleusComponentBase from '@/shared/application/nucleus-component-base';
import { Component } from 'vue-property-decorator';
var builder = require('utm-builder');
import Swal from 'sweetalert2'
import Clipboard from 'v-clipboard'
@Component
export default class HomeComponent extends NucleusComponentBase {

    linkSource = {
        link: "",
        campaign: "",
        source: "",
        medium: ""
    }
    username = "";
    public beforeMount() {
        this.getUserName();
        
        this.linkSource.medium = "affiliate";
    }

    createLink() {
        var message = "";
        if (this.linkSource.link == "") {
            message += "Lütfen oluşturmak istediğiniz linki giriniz. </br>"
        }
        if (this.linkSource.medium == "") {
            message += "Lütfen medium alanını doldurunuz. </br>"
        }
        if (this.linkSource.campaign == "") {
            message += "Lütfen kampanya alanını doldurunuz. </br>"
        }
        if (message != "") {
            this.swalAlert("error", message);
            return;
        }



        var utmLink = builder(this.linkSource.link, this.linkSource.source, this.linkSource.medium, this.linkSource.campaign);
        console.log(utmLink);
        var encodedLink = encodeURIComponent(utmLink);

        console.log(encodedLink)
        fetch('https://newtvlink.com/rest/v2/short-urls/shorten?apiKey=2c5966c8-9cc3-49ca-89bf-891f883ebd49&longUrl=' + encodedLink + '&format=json')
            .then(response => response.json())
            .then(data => {
                console.log(data.shortUrl)
                Swal.queue([{
                    title: 'Size Özel Link Oluşturuldu',
                    confirmButtonText: 'Linki Kopyala',

                    showLoaderOnConfirm: true,
                    preConfirm: () => {

                        (this as any).$clipboard(data.shortUrl)
                        Swal.insertQueueStep({
                            icon: 'success',
                            title: 'Link Başarılı Şekilde Kopyalandı'
                        })

                    }
                }])

            }


            );




    }
    getUserName() {
        var id = this.authStore.getTokenData()[
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
          ];
        console.log(id)
        this.nucleusService.get<IGetUserForCreateOrUpdateOutput>('/api/profile/GetUserNameWithId?id=' + id)
            .then((response) => {
                const result = response.content as IGetUserForCreateOrUpdateOutput;
                this.username = result.user.userName

                this.linkSource.source = "influencer_" + this.username.toLowerCase();

            });
    }


}